import * as React from "react";
import { useRef, useLayoutEffect, useMemo } from "react";
import { isInfiniteScrollUp } from "logview/helpers";
import useUpdateScrollPosition from "./useUpdateScrollPosition";
import ScrollPositionContext from "./ScrollPositionContext";
const _setBottomScrollPosition = (infiniteScrollDirection, tableRef) => {
  if (tableRef.current) {
    tableRef.current.scrollTop = isInfiniteScrollUp(infiniteScrollDirection) ? tableRef.current.scrollHeight - tableRef.current.clientHeight : 0;
  }
};
const ScrollPositionContextProvider = ({
  children,
  tableRef,
  pageRefs,
  scrollPositionUpdate,
  listStateStatus,
  tableHeaderRef,
  infiniteScrollDirection
}) => {
  const lastPositionRef = useRef(0);
  const finishedScrollPositionUpdateRef = useRef(true);
  const setFinishedScrollPositionUpdate = (finished) => {
    finishedScrollPositionUpdateRef.current = finished;
  };
  const setLastPosition = (position) => {
    lastPositionRef.current = position;
  };
  useLayoutEffect(() => {
    if (listStateStatus === "initial" || listStateStatus === "reset") {
      _setBottomScrollPosition(infiniteScrollDirection, tableRef);
    }
  }, [tableRef, listStateStatus, infiniteScrollDirection]);
  useUpdateScrollPosition({
    lastPositionRef,
    pageRefs,
    tableRef,
    tableHeaderRef,
    scrollPositionUpdate,
    setFinishedScrollPositionUpdate,
    infiniteScrollDirection
  });
  const contextValue = useMemo(
    () => ({
      finishedScrollPositionUpdateRef,
      lastPositionRef,
      setFinishedScrollPositionUpdate,
      setLastPosition
    }),
    []
  );
  return /* @__PURE__ */ React.createElement(ScrollPositionContext.Provider, { value: contextValue }, children);
};
export default ScrollPositionContextProvider;
